import WixPortfolioCallToAction from './WixPortfolioCallToAction';
import connect from './WixPortfolioCallToAction.container';

export default connect(WixPortfolioCallToAction);
